import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  FormControl,
  FormControlLabel,
  Checkbox as CheckboxMui
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
}));

/**
 * @param {{name:string,label:string, value:boolean, onChange:()=>void, options:Array}} props
 */

export default function Checkbox({ name, label, value, onChange }) {
  const classes = useStyles();
  return (
    <FormControl className={classes.formControl} variant="outlined">
      <FormControlLabel control={<CheckboxMui name={name} checked={value} onChange={(e, v) => onChange({ target: { name: name, value: v }})} color="primary"/>} label={label}/>
    </FormControl>
  );
}
